import { Box, Text } from '@factorialco/deprecated-design-system'

export const Beneficiary = ({ name }: { name: string }) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s16">
      <Text.Normal size="200" ellipsis>
        {name}
      </Text.Normal>
    </Box>
  )
}
